<template>
  <div style="height:100%;">
    <van-nav-bar
      title="活动说明"
      left-text=""
      left-arrow
      @click-left="onClickLeft()">
    </van-nav-bar>

    <div class="dial">
    </div>
  </div>
  
</template>
<script>
import { Image, NavBar, NoticeBar, Swipe, SwipeItem, Tag, Toast } from "vant";
import { showToast } from 'vant'
import AppVue from "../../App.vue";
var light_timer; //灯光定时器
export default {
  name: "dial",
  data() {
    return {
      
    };
  },
  created() {
  },
  computed: {
    isLogined() {
      return this.$store.state.isLogin;
    },
  },
  methods: {
    
     onClickLeft() {
      this.$router.back(-1);
    },
 
    //设置概率
    set() {
      var winIndex;
      //方法2
      var __rand__ = Math.random();
      if (__rand__ < 0.3) winIndex = 2;
      else if (__rand__ < 0.6) winIndex = 1;
      else if (__rand__ < 0.99) winIndex = 4;
      else if (__rand__ < 0.92) winIndex = 3;
      else if (__rand__ == 0.99) winIndex = 0;
 
      return winIndex;
    }
  },
  components: {
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [Toast.name]: Toast,
    [NoticeBar.name]: NoticeBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
};
</script>
<style scoped>
.dial{
  height: 135%;
  width: 100%;
  position: relative;
  background-image: url('../../assets/draw2026/draw_detai.png');
  background-repeat:no-repeat;
  overflow: hidden;
  background-size: contain;
  max-width: 100%;
}

</style>